import React from "react";

function ResidencyBasics(props) {

    return (
        <>
            <aside className="basics">
                <div className="basics-title-container text-center d-flex justify-content-between">
                    <div className="basics-title">
                        <h4>Basics</h4>
                    </div>
                    <img src="/images/basics.png" className="basics-logo"></img>
                </div>
                <div className="widget-body">

                    <div className="booktext">
                        <ul className="basics-list">
                            <li className="basics-list-item">
                                Accommodation in a private room with mountain views                            
                            </li>
                            <li className="basics-list-item">
                                Select a residency length from one to six weeks
                            </li>
                            <li className="basics-list-item">
                                All inclusive - breakfast, lunch, dinner, snacks and drinks included
                            </li>
                            <li className="basics-list-item">
                                Return transport from Toulouse included                            
                            </li>
                        </ul>
                    </div>

                </div>
            </aside>
        </>
    );
}

export default ResidencyBasics;